import type {
    CreatureVitalityFinalDefaultsInput,
    CreatureVitalityFinalDefaultsResult,
    CreatureVitalityNumberCell,
} from '../types';

export const FRESH_VITALITY_STATUS_ID = 'FF30B76E-785D-2CAF-FC66-C131D0548808';
const integer = (value: number | null | undefined): number => {
    const result = Math.trunc(Number.isFinite(value) ? value! : 0);
    return Object.is(result, -0) ? 0 : result;
};
const first = (cell: CreatureVitalityNumberCell): number | null | undefined => Array.isArray(cell) ? cell[0] : undefined;

/** Apply the finalizer's status default and legacy `[0]` current-vitality clamp exactly. */
export function compileCreatureVitalityFinalDefaults(input: CreatureVitalityFinalDefaultsInput): CreatureVitalityFinalDefaultsResult {
    const currentAtZero = integer(first(input.vCurrent));
    const baseMaxAtZero = integer(first(input.vMax));
    const effectiveAtZero = first(input.effectiveVMax);
    let vCurrent: CreatureVitalityNumberCell = Array.isArray(input.vCurrent) ? [...input.vCurrent] : input.vCurrent;
    let warnedZeroBase = false;

    if (effectiveAtZero !== undefined && effectiveAtZero !== null) {
        const effectiveMax = integer(effectiveAtZero);
        if (effectiveMax > 0 && currentAtZero > effectiveMax && Array.isArray(vCurrent)) {
            vCurrent[0] = effectiveMax;
        }
    } else if (baseMaxAtZero === 0 && currentAtZero > 0) {
        warnedZeroBase = true;
    }

    return {
        v_status: input.hasVStatus ? input.vStatusId : FRESH_VITALITY_STATUS_ID,
        v_current: vCurrent,
        warned_zero_base: warnedZeroBase,
    };
}
